/**
 * Error Logger Utility
 *
 * Integration with @infra/logger for structured error tracking.
 */

import type { LogContext } from '@infra/logger';
import { logger } from '@infra/logger';

/**
 * Log a 404 not found error
 *
 * @param context - Logging context
 */
export function logNotFoundError(context: {
  readonly path?: string | undefined;
  readonly appName?: string | undefined;
  readonly customContext?: Record<string, unknown> | undefined;
}): void {
  const logContext: LogContext = {
    service: context.appName ?? 'unknown-app',
    errorType: '404',
    path: context.path,
    ...context.customContext
  };

  logger.info('Page not found', logContext);
}

/**
 * Log a 500 application error
 *
 * @param context - Logging context
 */
export function logApplicationError(context: {
  readonly error: Error;
  readonly digest?: string | undefined;
  readonly appName?: string | undefined;
  readonly customContext?: Record<string, unknown> | undefined;
}): void {
  const logContext: LogContext = {
    service: context.appName ?? 'unknown-app',
    errorType: '500',
    error: context.error.message,
    digest: context.digest,
    stack: context.error.stack,
    ...context.customContext
  };

  logger.error('Application error', logContext);
}
